import { useState, useEffect, useRef } from "react";
import useStyles from "./styles/becomemember";
import { becomeMemberData } from "../../static/new-landing-page/new-landing-data";
import ButtonBlue from "../../components/ButtonBlue";
import { withTranslation } from "../../i18n";
import ChecklistItem from "./components/ChecklistItem";
import { Hidden } from "@material-ui/core";


const BecomeMember = ({ t, i18n, redirect }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const classes = useStyles();
    const language = i18n.language
    const data = becomeMemberData[language] || becomeMemberData.en
    const intervalRef = useRef(null);

    // Auto slide tiap 5 detik
    useEffect(() => {
        const startAutoSlide = () => {
            intervalRef.current = setInterval(() => {
                setCurrentSlide((prevSlide) => {
                    // Jika sudah di slide terakhir, kembali ke slide 0
                    if (prevSlide >= data.slide.mobile.length - 1) {
                        return 0;
                    }
                    // Jika belum di slide terakhir, lanjut ke slide berikutnya
                    return prevSlide + 1;
                });
            }, 5000); // 5 detik = 5000ms
        };

        startAutoSlide();

        // Cleanup interval ketika component unmount
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [data.slide.mobile.length]);

    // Function untuk handle click pada content item
    const handleContentClick = (index) => {
        // Set slide sesuai index yang diklik
        setCurrentSlide(index);

        // Reset timer dengan clear interval yang ada dan buat yang baru
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }

        // Buat interval baru untuk reset timer
        intervalRef.current = setInterval(() => {
            setCurrentSlide((prevSlide) => {
                if (prevSlide >= data.slide.mobile.length - 1) {
                    return 0;
                }
                return prevSlide + 1;
            });
        }, 5000);
    };

    function renderImageDesktop() {
        return (
            <div className={classes.ctnImage}>
                <img src={data.slide.desktop[currentSlide]} alt="why-myfitsociety" loading="lazy" />
            </div>
        )
    }

    function renderImageMobile() {
        return (
            <div className={classes.ctnImage}>
                <img src={data.slide.mobile[currentSlide]} alt="why-myfitsociety" loading="lazy" />
            </div>
        )
    }

    function renderContent() {
        return (
            <div className={classes.ctnContent}>
                <div className={classes.contentWrapper}>
                    <h2 className={classes.title}>{data.title}</h2>
                    <div className={classes.ctnChecklist}>
                        {data.content.map((item, index) => (
                            <ChecklistItem item={item} index={index} key={index} currentSlide={currentSlide} handleContentClick={handleContentClick} />
                        ))}
                    </div>
                    <div className={classes.ctnButton}>
                        <ButtonBlue isPulse onClick={redirect} label={data.button} />
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className={classes.root}>
            <Hidden mdDown>
                <div className={classes.container}>
                    {renderContent()}
                    {renderImageDesktop()}
                </div>
            </Hidden>

            <Hidden lgUp>
                <div className={classes.container}>
                    {renderImageMobile()}
                    {renderContent()}
                </div>
            </Hidden>
        </div>
    );
};

export default withTranslation(["myfitsociety"])(BecomeMember);